const BREAKPOINTS = {
  mobile: 'mobile',
  tablet: 'tablet',
  desktop: 'desktop',
}

export const useResponsive = () => {
  const { $viewport } = useNuxtApp()

  const isMobile = computed(() => {
    return $viewport.match(BREAKPOINTS.mobile)
  })

  const isMobileOrTablet = computed(() => {
    return $viewport.isLessThan(BREAKPOINTS.desktop)
  })

  const isTablet = computed(() => {
    return $viewport.match(BREAKPOINTS.tablet)
  })

  const isDesktop = computed(() => {
    return $viewport.match(BREAKPOINTS.desktop)
  })

  const isDesktopOrTablet = computed(() => {
    return $viewport.isGreaterThan(BREAKPOINTS.mobile)
  })

  return {
    breakpoint: $viewport.breakpoint,
    isMobile,
    isMobileOrTablet,
    isTablet,
    isDesktop,
    isDesktopOrTablet,
  }
}
